<template>
	<component
		:is="tag"
		class="font-prenton-cond text-2xl tracking-2xl xl:text-3xl"
	>
		<slot></slot>
	</component>
</template>

<script lang="ts" setup>
withDefaults(
	defineProps<{
		tag?: string;
	}>(),
	{
		tag: "h5",
	},
);
</script>
